import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import OrganisationSKUItem from '../OrganisationSKU/OrganisationSKUItem'
import Accordion from '../../Accordion/Accordion'
import CollectionItem from '../../Collection/CollectionItem'

const OrganisationProductsItem = ({ productData, onClick, isExpanded }) => {
  const { t } = useTranslation(['organisation', 'common'])
  const navigate = useNavigate()

  const editProduct = (e) => {
    e.preventDefault()
    navigate(`/dashboard/organisation/products/${productData.id}`)
  }

  const addSKU = (e) => {
    e.preventDefault()
    navigate(`/dashboard/organisation/products/${productData.id}/sku/new`)
  }

  const editSKU = (sku) => {
    navigate(`/dashboard/organisation/products/${productData.id}/sku/${sku.id}`)
  }

  return (
    <Accordion collapsed={!isExpanded} additionalClass="ctp-shop-item">
      <Accordion.Head handleClick={onClick}>
        <CollectionItem border={false} hover={false} padding={false}>
          <span>{productData.name}</span>
          <button className="button button-primary" onClick={editProduct}>
            {t('common:actions.edit')}
          </button>
        </CollectionItem>
      </Accordion.Head>
      <Accordion.Body>
        <div className="ctp-shop-item__sku-list">
          {productData.sku.length > 0 &&
            productData.sku.map((el) => (
              <OrganisationSKUItem
                key={el.id}
                sku={el}
                productId={productData.id}
                onEdit={editSKU}
              />
            ))}
          <button className="button button-primary" onClick={addSKU}>
            {t('organisation:shared.actions.addSubservice')}
          </button>
        </div>
      </Accordion.Body>
    </Accordion>
  )
}

OrganisationProductsItem.propTypes = {
  productData: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
}

export default OrganisationProductsItem
